import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WrapperHttpService } from '../../../services/wrapper-http-service';
import { API_URL } from '../../../../services/config';
import { NfSearchRequest } from './models/nf-search.model';
import { NfSearchResponse } from './models/nf-summary.model';
import { NfVerificationResponse, NfStatusHistoryResponse, NfStatusUpdateRequest } from './models/nf-details.model';

@Injectable({
  providedIn: 'root',
})
export class NfListService {
  constructor(private http: WrapperHttpService) {}

  search(payload: NfSearchRequest): Observable<NfSearchResponse> {
    return this.http.withLoading().post<NfSearchResponse>(`${API_URL}/nota-fiscal/verifications/search`, payload);
  }

  getById(id: number): Observable<NfVerificationResponse> {
    return this.http.withLoading().get<NfVerificationResponse>(`${API_URL}/nota-fiscal/verifications/${id}`);
  }

  getStatusHistory(id: number): Observable<NfStatusHistoryResponse[]> {
    return this.http
      .withLoading()
      .get<NfStatusHistoryResponse[]>(`${API_URL}/nota-fiscal/verifications/${id}/status-history`);
  }

  updateStatus(id: number, payload: NfStatusUpdateRequest): Observable<NfVerificationResponse> {
    return this.http
      .withLoading()
      .put<NfVerificationResponse>(`${API_URL}/nota-fiscal/verifications/${id}/status`, payload);
  }
}
